import React from 'react';
import './Contact.scss';

const Contact = () => {
    return (
        <div className='contact-container'>
            <h2>Contact Us</h2>
            <p>If you have any questions or need support, feel free to reach out to us!</p>
            <div className='contact-info'>
                <div className='qr-code'>
                    none
                </div>
                <div className='contact-details'>
                    none
                </div>
            </div>
        </div>
    );
};

export default Contact;